import {ReactNode} from 'react';

import {ContactSourcesEnum} from '../../../../../libs/shared/core/src/models/api/contactModel';

/** Minimum width of the viewer. */
export const viewerMinWidth = 540;

/** Channel-specific logic to render recipient handles. */
type HandleRenderers = {[T in ContactSourcesEnum]?: (handle: string) => ReactNode};
export const handleRenderers: HandleRenderers = {
  [ContactSourcesEnum.EMAIL]: (handle) => ['<', handle, '>'],
  [ContactSourcesEnum.TWITTER]: (handle) => handle,
  [ContactSourcesEnum.PHONE]: (handle) => ['(', handle, ')'],
};
